<ng-template #ModalExibirRelatorio>
  <div class="modal-content" class="conteudo__relatorio">
    <div class="modal-header">
      <a>Relatório</a>
      <mat-icon class="btn-fechar" (click)="fecharModal()">close</mat-icon>
    </div>
      <app-relatorio-franquia-global *ngIf="this.empresaRelatorioCabecalho.razaoNotaFiscalRelatorioTipo === '1'"></app-relatorio-franquia-global>
      <app-relatorio-taxa-fixa-e-producao *ngIf="this.empresaRelatorioCabecalho.razaoNotaFiscalRelatorioTipo === '2'"></app-relatorio-taxa-fixa-e-producao>
      <app-relatorio-franquia-por-maquina *ngIf="this.empresaRelatorioCabecalho.razaoNotaFiscalRelatorioTipo === '3'"></app-relatorio-franquia-por-maquina>
      <app-relatorio-informatica *ngIf="this.empresaRelatorioCabecalho.razaoNotaFiscalRelatorioTipo === '4'"></app-relatorio-informatica>
      <div *ngIf="this.empresaRelatorioCabecalho.razaoNotaFiscalRelatorioTipo == null" class="mensagem__erro">
        Não foi possível obter os dados do relatório.
      </div>
  </div>
    <div class="div__exportar">
      <app-botoes-files
          *ngIf="this.empresaRelatorioCabecalho.razaoNotaFiscalRelatorioTipo !== null"
          (OnClickApplyPDFButton)="exportarPdf();"
          (OnClickApplyCSVButton)="exportarCsv();"
          (OnClickApplyXLSXButton)="exportarXlsx();"
      ></app-botoes-files>
  </div>
</ng-template>
